import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule} from '@angular/material/button';

import { ListingModule } from '../listing/listing.module';
import { DirectivesModule } from '../../directives/directive.module';
import { VarModule } from '../../directives/ngVar';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { DocumentsDialog } from './documents-dialog';
import { DocumentsModule } from './documents.module';

@NgModule({
  declarations: [
    DocumentsDialog
  ],
  imports: [
    CommonModule,
    DocumentsModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ListingModule,
    DirectivesModule,
    ReactiveFormsModule,
    VarModule
  ],
  exports: [
    DocumentsDialog
  ]
})
export class DocumentsDialogModule {}
